import React from 'react'
import PropTypes from 'prop-types'
import MemberSelector from './member-selector'

const AddMember = ({ disabled, openLeague, member, setMember, onAddMember}) => {
  const addMember = (e) => {
    e.preventDefault()
    onAddMember({
      player_id: member.value,
      image_url: member.image,
      name: member.name,
      prefer_position: member.prefer_position,
      phone: member.phone,
      country_code: member.country_code,
      skill_level: member.skill_level,
      captain: false,
    })
  }  

  return <div className='add-new-member'>
    <MemberSelector openLeague={openLeague} onSelect={setMember} member={member} />
    <button className='add-member-button' onClick={addMember} disabled={disabled}>
      Add&nbsp;&nbsp;<i className='fa fa-plus'></i>
    </button>
  </div>
}

AddMember.propTypes = {
  disabled: PropTypes.bool,
  openLeague: PropTypes.bool,
  member: PropTypes.object,
  setMember: PropTypes.func.isRequired,
  onAddMember: PropTypes.func.isRequired,
}

export default AddMember
